import { matchPath } from "../../Router/utils";
import { type SubNavigationConfig } from "../type";
type IsItemActive = (
  path: string,
  locationPathname: string,
  subPaths: string[]
) => boolean;
export const isItemActive: IsItemActive = (
  path,
  locationPathname,
  subPaths
) => {
  const isMainPathActive = matchPath(path, locationPathname);
  const isAnySubRouteActive = subPaths.some((path) =>
    matchPath(path, locationPathname)
  );
  return !!isMainPathActive || !!isAnySubRouteActive;
};

/**
 * TODO: Fix routing hierarchy
 * Because of the subroutes automations/* & automations/templates (automations subroute has further automations/create & automations/{id} within)
 * In order for the menu items to have the correct active state even after we match the path we check if there is a more exact matching with other subroutes.
 */
export const isSubItemActive = (
  path: string,
  locationPathname: string,
  subRoutes: SubNavigationConfig["subRoutes"]
): boolean => {
  const isMatch = matchPath(path, locationPathname);
  return (
    isMatch &&
    !subRoutes.find(
      (subRoute) =>
        subRoute.path !== path && subRoute.href === window.location.pathname
    )
  );
};
